import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LogoMark } from "@/components/Logo";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH.
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match ? decodeURIComponent(match[1]) : null;

    // Clear hash from URL immediately
    if (window.history?.replaceState) {
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
    }

    if (!session_id) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        await api.post("/auth/google-session", { session_id });
        await refresh();
        toast.success("Google ile giriş başarılı");
        navigate("/dashboard", { replace: true });
      } catch (err) {
        toast.error(formatApiError(err));
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F2F2F2]" data-testid="auth-callback">
      <div className="text-center">
        <div className="flex justify-center mb-6"><LogoMark size={44} /></div>
        <Loader2 className="mx-auto animate-spin text-[#1E3A5F]" size={28} />
        <div className="mt-4 font-mono-aq text-xs tracking-[0.22em] uppercase text-[#4A4A4A]">Signing in…</div>
      </div>
    </div>
  );
}
